import API from './API';
var TicketService = {
    getTicket: function (id, config) {
        return API.get("/tickets/".concat(id), config);
    },
    getTickets: function (config) {
        return API.get('/tickets', config);
    }
};
export default TicketService;
